const ACCESS_TOKEN = 'ACCESS_TOKEN';
const CURRENT_ENTITY_ID = 'CURRENT_ENTITY_ID'
import * as Cookies from 'js-cookie'

function localStorageExist(){
  var test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch(e) {
    return false;
  }
}

export function storage(){
  if(localStorageExist()){
    return localStorage
  }
  return Cookies
}

export function setAccessToken(rememberMe, accessToken){
  if(rememberMe && localStorageExist()){
    localStorage.setItem(ACCESS_TOKEN, accessToken)
  }
  Cookies.set(ACCESS_TOKEN, accessToken)
}

export function getAccessToken(){
  var token = null;
  if(localStorageExist()){
    token = localStorage.getItem(ACCESS_TOKEN)
  }
  token = token || Cookies.get(ACCESS_TOKEN)

  return token
}

export function removeAccessToken(){
  if(localStorageExist()){
    localStorage.removeItem(ACCESS_TOKEN)
  }
  Cookies.remove(ACCESS_TOKEN)
}

export function setCurrentEntityId(entityId) {
  if(localStorageExist) {
    localStorage.setItem(CURRENT_ENTITY_ID, entityId);
  }
  Cookies.set(CURRENT_ENTITY_ID, entityId);
}

export function getCurrentEntityId() {
  var currentEntityId = null;
  if(localStorageExist()) {
    currentEntityId = localStorage.getItem(CURRENT_ENTITY_ID);
  }
  currentEntityId = currentEntityId || Cookies.get(CURRENT_ENTITY_ID);

  if(currentEntityId != null) {
    currentEntityId = parseInt(currentEntityId);
  }

  return currentEntityId;
}

export function removeCurrentEntityId(){
  if(localStorageExist()){
    localStorage.removeItem(CURRENT_ENTITY_ID);
  }
  Cookies.remove(CURRENT_ENTITY_ID);
}



// WEBPACK FOOTER //
// ./src/backend/storage.js